import React from "react";
import {
  Box,
  Flex,
  HStack,
  VStack,
  Spacer,
  Skeleton,
  SkeletonCircle,
} from "@chakra-ui/react";

/**
 * Placeholder shown while a MeetingCard's data is loading.
 * Mirrors the real card's two-section layout so the page doesn't jump
 * when the actual cards replace the skeletons.
 */
const MeetingCardSkeleton: React.FC = () => {
  return (
    <Box as="article" position="relative" w="full" maxW="560px" mb={4}>
      <Flex
        overflow="hidden"
        bg="white"
        borderRadius="lg"
        boxShadow="sm"
        border="1px solid"
        borderColor="gray.200"
        position="relative"
      >
        {/* Left section */}
        <Flex direction="column" flex="1" p={6}>
          <Skeleton height="18px" width="70%" mb={2} />
          <Skeleton height="12px" width="40%" mb={2} />
          <Skeleton height="12px" width="55%" mb={1} />
          <Skeleton height="12px" width="50%" mb={3} />

          <HStack spacing={2} mt="auto">
            <Skeleton height="32px" width="90px" borderRadius="md" />
            <Skeleton height="32px" width="90px" borderRadius="md" />
          </HStack>
        </Flex>

        {/* Right section */}
        <Flex direction="column" justify="space-between" p={6} bg="white" minW="200px">
          <Skeleton height="20px" width="60px" borderRadius="sm" />

          <Spacer />

          <VStack spacing={2} align="stretch" mt={5}>
            <Flex alignItems="center">
              <Skeleton height="12px" width="90px" mr={2} />
              <SkeletonCircle size="30px" />
            </Flex>
          </VStack>

          <Skeleton height="32px" width="100%" borderRadius="md" mt={4} />
        </Flex>
      </Flex>
    </Box>
  );
};

export default MeetingCardSkeleton;
